import Grid from '@/global/components/ui/Grid'
import { FormDatePicker, FormField } from 'global/components/Form'

interface Props {
    labelDataOrigem?: string
}

export default function FormNovaCompensacaoFeriado({
    labelDataOrigem = 'Data do feriado',
}: Props) {
    return (
        <Grid container>
            <FormField name="empresaId" className="hidden!" />
            <FormField name="funcionarioId" className="hidden!" />
            <Grid item xs={12} sm={6}>
                <FormDatePicker
                    label="Data em que o funcionário trabalhou"
                    name={'dataCompensacao'}
                    type="date"
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormDatePicker
                    label={labelDataOrigem}
                    name={'dataFeriado'}
                    type="date"
                />
            </Grid>
        </Grid>
    )
}
